import { cva } from 'class-variance-authority';

export const container = cva([
  'px-3 py-1 w-fit',
  'text-xs font-medium text-start',
  'rounded-md shadow-sm',
]);
